import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./DashboradExamCatPopup.css";

import examImg from "../assets/images/state-img.png";
//Import Footer SVg
import { ExamCatIcon } from '../components/SvgIcons';
const isMobile = window.innerWidth < 576;
const examList = [
  { name: "Banking Exam", total: 27, selected: 0,  icon: examImg  },
  { name: "Banking Exam", total: 27, selected: 4 , icon: examImg},
  { name: "SSC Exam", total: 27, selected: 1, icon: examImg },
  { name: "Fci Exam", total: 27, selected: 3, icon: examImg},
  { name: "Patwari", total: 27, selected: 2 , icon: examImg},
   { name: "SSC Exam", total: 27, selected: 1, icon: examImg },
  { name: "Fci Exam", total: 27, selected: 3, icon: examImg},
  { name: "Patwari", total: 27, selected: 2 , icon: examImg},
];

const ChangeExamCategoryPage = ({ show, onHide }) => {
  const isMobile = window.innerWidth < 576;

  const [sheetHeight, setSheetHeight] = useState(75);
  const [isDragging, setIsDragging] = useState(false);

  const startY = React.useRef(0);
  const startHeight = React.useRef(75);

  const handleDragStart = (e) => {
    if (!isMobile) return;

    setIsDragging(true);
    startY.current = e.touches ? e.touches[0].clientY : e.clientY;
    startHeight.current = sheetHeight;
  };

  const handleDragMove = (e) => {
    if (!isMobile || !isDragging) return;

    const currentY = e.touches ? e.touches[0].clientY : e.clientY;
    const delta = startY.current - currentY;

    // Instagram-like resistance
    let nextHeight = startHeight.current + delta / 4;

    if (nextHeight > 90) nextHeight = 90;
    if (nextHeight < 40) nextHeight = 40;

    requestAnimationFrame(() => {
      setSheetHeight(nextHeight);
    });
  };

  const handleDragEnd = () => {
    if (!isMobile) return;

    setIsDragging(false);

    //  Close threshold (Instagram-like)
    if (sheetHeight < 55) {
      onHide();
    } else if (sheetHeight < 70) {
      setSheetHeight(70); 
    } else {
      setSheetHeight(90); 
    }

    startY.current = 0;
  };

  return (
      <Modal
      show={show}
      onHide={onHide}          
      centered
      backdrop={true}         
      keyboard={true}          
      dialogClassName="exam-category-modal"
    >
   <div
  className="modal-content-custom"
 style={
  isMobile
    ? {
        height: `${sheetHeight}vh`,
        transition: isDragging
          ? "none"
          : "height 0.35s cubic-bezier(0.33, 1, 0.68, 1)",
      }
    : {}
}
>


        {/* Header */}
        <div className="modal-header-custom">
              {/* 🔥 Drag Handle – MOBILE ONLY */}
          {isMobile && (
            <div
              className="drag-handle"
              onTouchStart={handleDragStart}
              onTouchMove={handleDragMove}
              onTouchEnd={handleDragEnd}
              onMouseDown={handleDragStart}
              onMouseMove={handleDragMove}
              onMouseUp={handleDragEnd}
            />
          )}
          <h5 className="fw-bold">Select To Change Exam Category</h5>
         {!isMobile && (
            <button className="close-btn" onClick={onHide}>
              <i className="bi bi-x"></i>
            </button>
          )}
        </div>

        {/* Body */}    
        <div className="modal-body-custom">
          {examList.map((item, index) => (
            <div className="exam-card" key={index}>

              <div className="exam-card-bg">
                <ExamCatIcon />
              </div>

              <div className="exam-card-content  d-flex align-items-center justify-content-between w-100">
                <div className="exam-left">
                 <img
                    src={item.icon}
                    alt={item.name}
                    className="exam-icon"
                    />
                  <div>
                    <h6 className="fw-bold mb-1">{item.name}</h6>
                    <p className="fw-semibold grayText">
                      {item.total} Exam <span className="fw-medium"> ({item.selected} selected)</span>
                    </p>
                  </div>
                </div>
                  <span className="chevron-btn">
            <i className="bi bi-chevron-right"></i>
          </span>
              </div>
             
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="modal-footer-custom">
          <button className="add-btn fw-bold">Add Exam Category</button>
        </div>

      </div>
    </Modal>
  );
};

export default ChangeExamCategoryPage;
